module.exports = __webpack_public_path__ + "img/TZS09440.840784e4.jpeg";